// Suggested Services menuGroup ID
export const SUGGESTED_SERVICES = 'suggested-services';
